import * as React from 'react';

import { InternalTransactionsFromStore } from './EditMerchantOrder';
import { EditItem } from '../Layout';
import i18n, { getDateFormatOptions } from '@/utils/i18n';
import { Table } from 'reactstrap';
import { ContentSection } from '../Layout/ContentSection';

/**
 * Only to be used in EditMerchantOrder
 */
export const InternalTransactions = function internalTransactions(props: {
  internalTransactionsFromStore: InternalTransactionsFromStore[];
}) {
  function getStyleForRow(i: InternalTransactionsFromStore) {
    if (i.containerTypeName === 'Total') {
      return {
        fontWeight: 'bold',
        backgroundColor: '#eee',
        borderTop: '2px double #000',
        borderBottom: '2px double #000',
      };
    }
    return {};
  }

  const totals: Record<string, number> = {};
  props.internalTransactionsFromStore.forEach(
    (i) => (totals[i.storeName] = (totals[i.storeName] ?? 0) + i.count),
  );
  const internalTransactionsFromStoreWithTotals =
    props.internalTransactionsFromStore.concat(
      Object.keys(totals).map((k) => ({
        storeName: k,
        count: totals[k],
        containerTypeName: 'Total',
        bookingDates: [],
      })),
    );
  const rows = [...internalTransactionsFromStoreWithTotals]
    .sort((a, b) => {
      if (a.storeName === b.storeName) {
        if (a.containerTypeName === 'Total') {
          return 1;
        }
        if (b.containerTypeName === 'Total') {
          return -1;
        }
        return a.containerTypeName.localeCompare(b.containerTypeName);
      }
      return a.storeName.localeCompare(b.storeName);
    })
    .map((i) => (
      <tr key={i.storeName + i.containerTypeName} style={getStyleForRow(i)}>
        <td>{i.storeName}</td>
        <td>{i.containerTypeName}</td>
        <td>{i.count}</td>
        <td>
          {(i.bookingDates ?? [])
            .map((d) =>
              new Date(d).toLocaleDateString(
                i18n.language,
                getDateFormatOptions(false),
              ),
            )
            .join('; ')}
        </td>
      </tr>
    ));

  return (
    <ContentSection title="Internal Transactions" locked>
      <Table striped hover>
        <thead>
          <tr>
            <th>Store</th>
            <th>Container Type</th>
            <th>Count</th>
            <th>Booking Dates</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </Table>
    </ContentSection>
  );
};
